import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Testimonial.css";
import { TESTIMONIALS } from "../../constants/testimonials";

const carouselOptions = {
  className: "owl-carousel owl-theme",
  loop: true,
  center: true,
  margin: 0,
  responsiveClass: true,
  nav: true,
  responsive: {
    0: { items: 1, nav: true },
    680: { items: 2, nav: true, loop: false },
    1000: { items: 3, nav: true },
  },
};

const Testimonial = () => {
  return (
    <div className="main_testimonial">
      <div className="container gtco-testimonials pt-5">
        <h2 className="client_head">
          Testimonials from Our Valued Clients
        </h2>
        <p className="client_subhead">
          Discover what clients of BestechVision have to say about our web
          development, software, and digital solutions — and how our team has
          helped businesses grow with technology.
        </p>
        <OwlCarousel {...carouselOptions}>
          {TESTIMONIALS.map((testimonial) => (
            <div key={testimonial.id}>
              <div className="card text-center">
                <img
                  className="card-img-top"
                  src={testimonial.image}
                  alt={testimonial.name}
                />
                <div className="card-body">
                  <h5 className="feedback_name">
                    {testimonial.name}
                    <br />
                    <span className="feedback_desig">
                      {testimonial.designation}
                    </span>
                  </h5>
                  <p className="card-text feedback_content">
                    &ldquo;{testimonial.quote}&rdquo;
                  </p>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Testimonial;
